import { render } from "./TheHeader.vue?vue&type=template&id=ed667bfe&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=ed667bfe&scoped=true&lang=css"

import exportComponent from "C:\\8 Extension Folder\\8.0 Extension Folder\\8.02\\SMMPortfolioSite\\photographydays-login\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed667bfe"]])

export default __exports__